import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import { NavLink, useNavigate } from "react-router-dom";
import configServ from "../../services/config";

//Icon Imports
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Zoom from "@mui/material/Zoom";
import { motion, AnimatePresence } from "framer-motion";
import { Tooltip } from "@mui/material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";

// import SiteLogo from '../Assets/images/DovetailLogo.svg'
import SiteLogo from "../Assets/images/siteLogoWhite.svg";

import { useSelector, useDispatch } from "react-redux";
import { trigger } from "../../redux/reducers/SideExpand";
import MenuListCard from "../MenuListCard/MenuListCard";
import Logout from "../Logout/Logout";
import SellIcon from "@mui/icons-material/Sell";
import LoaderNew from "../Loader/LoaderNew";
import DescriptionIcon from "@mui/icons-material/Description";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import PasswordIcon from "@mui/icons-material/Password";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import LogoutIcon from "@mui/icons-material/Logout";
const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

// const AppBar = styled(MuiAppBar, {
//   shouldForwardProp: (prop) => prop !== 'open',
// })(({ theme, open }) => ({
//   zIndex: theme.zIndex.drawer + 1,
//   transition: theme.transitions.create(['width', 'margin'], {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   ...(open && {
//     marginLeft: drawerWidth,
//     width: `calc(100% - ${drawerWidth}px)`,
//     transition: theme.transitions.create(['width', 'margin'], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   }),
// }));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function CustomerSideBar() {
  const dispatch = useDispatch();
  const open = useSelector((state) => state.sideExpand.open);
  const { company_type } = useSelector((state) => state.admin);

  // const [isMenuExpanded, setIsMenuExpanded] = React.useState(false);
  const [isLogutDialogOpen, setIsLogutDialogOpen] = React.useState(false);
  // const [selectedMenu, setSelectedMenu] = React.useState(0);
  // const [hidden, setHidden] = React.useState(false);

  const handleDrawerClose = () => {
    // setOpen(false);
    dispatch(trigger());
  };

  //   const handleExpand = (number)=>{
  //     setSelectedMenu(number)
  //     setIsMenuExpanded(!isMenuExpanded)
  //   }

  //logout
  const handleLogout = () => {
    setIsLogutDialogOpen(!isLogutDialogOpen);
  };

  const navigate = useNavigate();
  const [expandedMenu, setExpandedMenu] = React.useState(null); // Track expanded menu
  const [menus, setMenus] = React.useState([]);

  const handleMenuClick = (menu) => {
    if (menu.submenus.length === 0) {
      navigate(menu.routes); // Navigate directly
    } else {
      setExpandedMenu(expandedMenu === menu.id ? null : menu.id); // Toggle submenu
    }
  };

  const handleSubmenuClick = (route) => {
    navigate(route);
  };

  const [loading, setLoading] = React.useState(false);

  const fetchMenuList = async () => {
    setLoading(true);
    try {
      const res = await configServ.getCustomerActiveMenusWithSubmenus();
      if (res.status === 200 && Array.isArray(res.data)) {
        setMenus(res.data || []);
      } else {
        setMenus([]);
        // toast.error("Failed to fetch menu list.");
      }
    } catch (e) {
      // toast.error("An error occurred!");
      console.log(e);
      setMenus([]);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchMenuList();
  }, []);

  // Icon mapping object
  const iconMapping = {
    dashboard: <DashboardIcon />,
    invoice: <DescriptionIcon />,
    product: <ProductionQuantityLimitsIcon />,
    purchasecustomer: <ShoppingBasketIcon />,
    payment: <AccountBalanceIcon />,
    profile: <AccountBoxIcon />,
    password: <PasswordIcon />,
    leadger: <LeaderboardIcon />,
    logout: <LogoutIcon />,
  };
  const getIcon = (iconName) => {
    return iconMapping[iconName.toLowerCase()] || null; // Return null if icon doesn't exist
  };

  const NavToolTip = ({ text, children }) => {
    return (
      <Tooltip
        TransitionComponent={Zoom}
        leaveDelay={200}
        title={text}
        placement="right"
        arrow
        sx={{ fontSize: "16px" }}
      >
        {children}
      </Tooltip>
    );
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Logout open={isLogutDialogOpen} setOpen={setIsLogutDialogOpen} />
      {/* <AppBar position="fixed" open={open} sx={{backgroundColor:'white', zIndex:-1}}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 5,
              ...(open && { display: 'none' }),
              color:'black'
            }}
          >
            <MenuIcon />
          </IconButton>
          <IconButton>
            <img src={SiteLogoInitial} alt="logoInitial" width='50' />
          </IconButton>
        </Toolbar>
      </AppBar> */}
      <Drawer
        variant="permanent"
        open={open}
        PaperProps={{
          sx: {
            backgroundColor: "#333",
          },
        }}
      >
        <DrawerHeader>
          <img
            src={SiteLogo}
            alt="logo"
            width="150"
            hidden={open ? false : true}
          />
          <IconButton onClick={handleDrawerClose}>
            {!open ? (
              <MenuIcon sx={{ color: "white" }} />
            ) : (
              <ChevronLeftIcon sx={{ color: "white" }} />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <LoaderNew /> {/* Replace with your loader icon/component */}
          </div>
        ) : (
          <>
            {" "}
            {/* Iterate Menus */}
            {menus.map((menu) => (
              <div key={menu.id}>
                {/* Main Menu */}
                <div
                  onClick={() => {
                    if (menu.name === "Log Out") {
                      handleLogout(); // Trigger the logout function
                    } else {
                      handleMenuClick(menu); // Handle other menu clicks
                    }
                  }}
                  style={{
                    cursor: "pointer",
                    padding: "10px",
                    color: "white",
                    display: "flex",
                    justifyContent: open ? "space-between" : "center",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px", // Add spacing between icon and name
                    }}
                  >
                    <NavToolTip text={menu.name}>
                      {getIcon(menu.icon)}
                    </NavToolTip>{" "}
                    {open && menu.name}
                  </span>
                  {menu.submenus.length > 0 &&
                    (expandedMenu === menu.id ? (
                      <ArrowDropUpIcon />
                    ) : (
                      <ArrowDropDownIcon />
                    ))}
                </div>

                {/* Submenus */}
                <AnimatePresence>
                  {expandedMenu === menu.id && menu.submenus.length > 0 && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      <ul style={{ listStyle: "none", paddingLeft: "20px" }}>
                        {menu.submenus.map((submenu) => (
                          <li key={submenu.id}>
                            <div
                              onClick={() => handleSubmenuClick(submenu.routes)}
                              style={{
                                cursor: "pointer",
                                padding: "8px",
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                                gap: "12px", // Add spacing for submenu items
                              }}
                            >
                              <NavToolTip text={submenu.name}>
                                {getIcon(submenu.icon)}
                              </NavToolTip>
                              {open && submenu.name}{" "}
                              {/* Only show name if sidebar is open */}
                            </div>
                          </li>
                        ))}
                      </ul>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </>
        )}
        <Divider />
      </Drawer>
    </Box>
  );
}
